import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Class_ETC_MsgError } from "../Class/Class_Etc";
import MsgDescription from "../Class/MsgDescription.json";
import Pathurl from "../Class/Pathurl.json";
import ConfigETC from "../Class/ConfigETC.json";
import Cookies from 'js-cookie';
 
import { CP_CheckPermission } from "../Class/Class_Permission"; 


function Login() {
  
  const [configData, setConfigData] = useState([]);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  
  
  useEffect(() => {
    GetConfig();
    //ทุกครั้งที่เข้าหน้า login จะต้องทำการ clear localStorage ใหม่
    ClearlocalStorage();
    if (isLoadedConfigData === true) {
      const keyDownHandler = (event) => {
        if (event.key === "Enter") {

          if (document.getElementById("cb_pdpa").checked === true) {
            if (
              document.getElementById("divLoadingProgress").style.display === "none"
            ) {
              event.preventDefault();
              onclickLogin();
            }
          }

        }
        else if (event.key === 'Escape') 
        {
          document.getElementById("modalPDPA_Close").click();
        }
      };
      document.addEventListener("keydown", keyDownHandler);
      return () => {
        document.removeEventListener("keydown", keyDownHandler);
      };
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  function ClearlocalStorage(){

    localStorage.clear();

    document.getElementById("cb_pdpa").checked = false
    document.getElementById("cb_remember").checked = false

    const Remember = Cookies.get('Remember' , { domain: configData.Cookie_Domain })

    if(Remember === "1"){

      const Comcode = Cookies.get('Comcode' , { domain: configData.Cookie_Domain })
      const Staffcode = Cookies.get('Staffcode' , { domain: configData.Cookie_Domain })

      document.getElementById("txt_Company_code").value = Comcode;
      document.getElementById("txt_Staff_code").value = Staffcode;
      document.getElementById("cb_remember").checked = true;
    }
  }

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }


  function onclickLogin() {

    document.getElementById("divLoadingProgress").style.display = "block";
    if (
      document.getElementById("txt_Company_code").value === "" ||
      document.getElementById("txt_Staff_code").value === "" ||
      document.getElementById("txt_Password").value === "" 
    ) {
      document.getElementById("divLoadingProgress").style.display = "none";
      Class_ETC_MsgError(MsgDescription.ERR004 , null)
    } 
    else {
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        "com_code": document.getElementById("txt_Company_code").value.trim(),
        "staff_code": document.getElementById("txt_Staff_code").value.trim(),
        "password": document.getElementById("txt_Password").value.trim()
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(configData.API_URL + "Login", requestOptions)
        .then((response) => response.json())
        .then((result) => {

          if (result.status_ID === 1) {
            localStorage.setItem("TStoken", result.token);
            localStorage.setItem("FullName_Th" , result.fullName_Th);
            localStorage.setItem("FullName_Eng" , result.fullName_Eng);
            localStorage.setItem("Staff_Code" , document.getElementById("txt_Staff_code").value);
            localStorage.setItem("staff_img_profile" , result.staff_img_profile);
            localStorage.setItem("com_display" , result.com_display);
            localStorage.setItem("com_img_display" , result.com_img_display);
            localStorage.setItem("com_img_loading" , result.com_img_loading);
            localStorage.setItem("per_menu_main" , result.per_menu_main);
            localStorage.setItem("per_menu_master" , result.per_menu_master);
            localStorage.setItem("per_menu_report" , result.per_menu_report);
            localStorage.setItem("workday_WT" , result.workday_WT);

            localStorage.setItem("supportsystem" , result.supportsystem);
            localStorage.setItem("service_list" , result.service_list);



            if(document.getElementById("cb_remember").checked === true){
              const expirationDate = new Date();
              expirationDate.setDate(expirationDate.getDate() + ConfigETC.CookieExpires);

              Cookies.set('Comcode', document.getElementById("txt_Company_code").value.trim(), { expires: expirationDate , domain: configData.Cookie_Domain }); 
              Cookies.set('Staffcode', document.getElementById("txt_Staff_code").value.trim(), { expires: expirationDate , domain: configData.Cookie_Domain }); 
              Cookies.set('Remember', "1", { expires: expirationDate , domain: configData.Cookie_Domain }); 
            }else{
              Cookies.remove('Comcode');
              Cookies.remove('Staffcode');
              Cookies.remove('Remember');
            }

            let first_permision = CP_CheckPermission("main" , ["my_timesheets_view"] , false , false);

            if(first_permision === true ){
              window.location.replace("../" + Pathurl.timesheet);
            }
            else {
              window.location.replace("../" + Pathurl.welcome);
            }

          } else {
            document.getElementById("divLoadingProgress").style.display = "none";
            Class_ETC_MsgError(result.status_Desc , null)
          }
        })
        .catch((error) => {
          document.getElementById("divLoadingProgress").style.display = "none";
          Class_ETC_MsgError(MsgDescription.ERR005 , null)
        });
    }


  }

  function onChange_Accept() {
    if (document.getElementById("cb_pdpa").checked === true) {
        document.getElementById("btn_Login").style.display = "";
        document.getElementById("btn_LoginF").style.display = "none";
    }
    else {
        document.getElementById("btn_Login").style.display = "none";
        document.getElementById("btn_LoginF").style.display = "";
    }
  }

  // function onCallMsg_AfterLogin() {
  //     oncbAccept();
  // }

  return (
    <>
      <Helmet>
        <title>Quiksheet | Login </title>
      </Helmet>
      <div className="login-page" style={{ minHeight: 306 }}>
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
          style={{ display: "none" }}
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
        <div className="login-box">
          {/* /.login-logo */}
          <div className="card card-outline ">
            <div className="card-header text-center">
              <div
                className="login-logo"
                style={{
                  verticalAlign: "bottom",
                  marginBottom: 0,
                  background: "url(images/header_bkg.jpg) repeat-x 0 0",
                  padding: 5,
                  backgroundColor: "none",
                }}
              >
                <img
                  src="../images/Logo/logo.png"
                  alt="Quiksheet"
                  className="logo-image"
                />
              </div>
              {/* /.login-logo */}
              {/*<span className="h4">
                <b> Timesheet</b>{" "}
              </span>
              */}
            </div>
            <div className="card-body">
              <p className="login-box-msg">Sign in to start your session</p>
              <div className="input-group mb-3">
                <input
                  type="text"
                  id="txt_Company_code"
                  className="form-control"
                  placeholder="Company code"
                  defaultValue={""}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-home" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Staff code"
                  id="txt_Staff_code"
                  defaultValue={""}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-user" />
                  </div>
                </div>
              </div>
              <div className="input-group mb-3">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  id="txt_Password"
                  defaultValue={""}
                />
                <div className="input-group-append">
                  <div className="input-group-text">
                    <span className="fas fa-key" />
                  </div>
                </div>
              </div>

              <div className="row">
                {/* /.col */}
                <div className="col-12 ml-4">
                  <input
                    id="cb_remember"
                    type="checkbox"
                    className="form-check-input"
                  />
                  <label htmlFor="cb_remember" className="text-normal text-muted"> Remember me</label>
                </div>
                {/* /.col */}
              </div>

              <div className="row">
                {/* /.col */}
                <div className="col-12 ml-4">
                  <input
                    id="cb_pdpa"
                    type="checkbox"
                    className="form-check-input"
                    onChange={onChange_Accept}
                  />
                  <label htmlFor="cb_pdpa" className="text-normal text-muted">I accept the privacy policy </label>
                  &nbsp;
                  <a href="#!"
                     id="btn_pdpa"
                     data-toggle="modal" data-target="#modal-PDPA"
                     className="btn btn-default btn-xs"
                  >
                  <span className="text-normal text-muted"><i className="nav-icon fa fa-file-alt"></i> Agreement</span>
                  </a>

                </div>
                {/* /.col */}
              </div>
             
               
              <div className="row pt-2">
                {/* /.col */}
                <div className="col-4">
                  <a
                    href="#!"
                    id="btn_Login"
                    className="btn btn-primary"
                    style={{display:"none"}}
                    onClick={onclickLogin}
                  >
                    <i className="nav-icon fa fa-arrow-circle-right" /> Log In
                  </a>
                  <button
                    id="btn_LoginF"
                    className="btn btn-default disabled"
                    disabled={true}
                  >
                    <i className="nav-icon fa fa-arrow-circle-right" /> Log In
                  </button>
                </div>
                <div className="col-8">
                  <div className="hidden-xs text-sm text-muted text-italic ">
                    <div className="text-sm-right">
                      <b>Version</b> 0.13
                    </div>
                    <div className="text-sm-right">10/06/2024</div>
                  </div>
                </div>
                {/* /.col */}
              </div>
            </div>
            {/* /.card-body */}
          </div>
          {/* /.card */}
        </div>
      </div>


      {/* ###################### Modal PDPA  ###################### */}
        
      <div className="modal fade" id="modal-PDPA" >
        <div className="modal-dialog modal-lg ">
          <div className="modal-content">
            <div className="modal-header">
                <h4 className="modal-title">
                    <i className="fa fa-file"/> นโยบายคุ้มครองข้อมูลส่วนบุคคล
                </h4>
              <button
                id="modalPDPA_Close"
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body direct-chat-messages" style={{height:"700px",overflowY:"scroll",overflowX:"hidden",color:"black"}}>
            <div className="container-fluid">
            <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                        <div className="text-big">
                          <span >บริษัท แฟลชเวิร์ค ทีม คอนซัลติ้ง จำกัด</span>
                        </div>
                          <div className="mailbox-read-message">
                            <>
                              <ul>
                                <p className="height-unset"><b>1. คำแถลงว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล</b></p>
                                <p className="">
                                  1.1 นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ (“นโยบายคุ้มครองข้อมูลส่วนบุคคล”) อธิบายวิธีการที่บริษัท แฟลชเวิร์ค ทีม คอนซัลติ้ง จำกัด (ซึ่งต่อไปนี้จะเรียกว่า “แฟลชเวิร์ค” “เรา” หรือ “ของเรา”) เก็บรวบรวม ใช้ เก็บรักษา เปิดเผย และ/หรือ โอนไปยังต่างประเทศ ซึ่งข้อมูลส่วนบุคคลของลูกค้าในปัจจุบันและอนาคต (ซึ่งต่อไปนี้จะเรียกว่า “คุณ” หรือ “ของคุณ”) ตามที่นิยามไว้ในนโยบายนี้ โดยมีวัตถุประสงค์เพื่อคุ้มครองความเป็นส่วนตัวของข้อมูลส่วนบุคคลของคุณ
                                </p>
                                <p className="">
                                  1.2 นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ใช้กับช่องทางการสื่อสารทั้งออนไลน์หรือออฟไลน์ที่เราเก็บรวบรวมข้อมูลส่วนบุคคลของคุณ ไม่ว่าทางต่อหน้า สถานที่ประกอบกิจการของเรา ทางโทรศัพท์ หรือทางออนไลน์ ผ่านทางอีเมล หรือแพลตฟอร์มโซเชียลมีเดีย (เช่น เว็บเพจ Facebook หรือ Line) และช่องทางอื่นๆ ที่เกี่ยวกับการให้บริการแก่คุณ รวมถึง เว็บไซต์ของเรา http://www.flashwork.co.th  และ/หรือเว็บไซต์อื่นๆ (“เว็บไซต์”) และปฏิสัมพันธ์อื่นๆ ระหว่างคุณกับเรา (ซึ่งต่อไปนี้จะรวมเรียกกันว่า “ช่องทางการสื่อสาร”)
                                </p>
                                <p className="">
                                  1.3 เพื่อให้บรรลุวัตถุประสงค์ของนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ “ข้อมูลส่วนบุคคล” หมายถึงข้อมูลส่วนบุคคลหรือข้อมูลที่สามารถระบุตัวตนได้ตามที่นิยามไว้ในกฎหมายที่ใช้บังคับ ซึ่งรวมถึงข้อมูลส่วนบุคคลที่มีความละเอียดอ่อน (ตามที่นิยามไว้ในนโยบายนี้)
                                </p>
                                <p className="">
                                  1.4 แฟลชเวิร์คมีความมุ่งมั่นในการดำเนินการเพื่อให้มั่นใจว่าความเป็นส่วนตัวของคุณจะได้รับความคุ้มครอง และการประมวลผลข้อมูลส่วนบุคคลของคุณจะเป็นไปตามกฎหมายและข้อบังคับที่เกี่ยวข้อง (ซึ่งอาจมีการแก้ไขเพิ่มเติมและมีการออกกฎหมายใหม่ใช้บังคับแทนเป็นครั้งคราว) เพื่อคุ้มครองข้อมูลส่วนบุคคลในประเทศที่เราเข้าไปและมุ่งหมายจะเข้าไปดำเนินธุรกิจ (“กฎหมายที่ใช้บังคับ”) เราจะเก็บรวบรวม ใช้ เก็บรักษา เปิดเผย และโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลของคุณตามนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้เท่านั้น
                                </p>
                                <p className="">
                                  1.5 โปรดอ่านเนื้อหาต่อไปนี้อย่างระมัดระวังเพื่อทำความเข้าใจมุมมองและการปฏิบัติของแฟลชเวิร์คเกี่ยวกับข้อมูล
                                  ส่วนบุคคลของคุณและวิธีการที่เราจะประมวลผลข้อมูลดังกล่าว ข้อมูลบางประการเกี่ยวกับคุณมีความจำเป็นสำหรับการจัดหาผลิตภัณฑ์และบริการให้แก่คุณ หากคุณไม่ตกลงที่จะให้ข้อมูลดังกล่าว เราจะไม่สามารถจัดหาผลิตภัณฑ์และบริการให้แก่คุณ และคุณจะไม่สามารถใช้หรือเข้าถึงฟังก์ชั่นและการใช้งานของบริการและผลิตภัณฑ์ของเราทั้งหมดได้
                                </p>
                                <p className="">
                                  1.6 โดยทั่วไปแล้วกิจกรรมของเรา (ซึ่งรวมถึงการให้บริการ และการจำหน่ายผลิตภัณฑ์) ไม่มุ่งเน้นที่ผู้เยาว์ คนเสมือนไร้ความสามารถ หรือคนไร้ความสามารถ ดังนั้น หากคุณมีอายุต่ำกว่า 20 ปี หรือยังไม่บรรลุนิติภาวะตามที่กำหนดในประเทศที่คุณอาศัยอยู่ เป็นคนเสมือนไร้ความสามารถ เป็นคนไร้ความสามารถ (แล้วแต่กรณี) เว้นแต่จะมีสิทธิตามกฎหมาย และคุณต้องการใช้บริการของเรา ใช้แอปพลิเคชันของเรา หรือบริการอื่นๆ จากเรา คุณจะต้องได้รับความยินยอมจากผู้ปกครองหรือผู้แทนโดยชอบธรรมก่อนติดต่อเราหรือก่อนให้ข้อมูลส่วนบุคคลแก่เรา เราไม่เก็บรวบรวมข้อมูลส่วนบุคคลหากเราทราบอยู่แล้วว่าข้อมูลดังกล่าวเป็นข้อมูลของผู้เยาว์ที่อายุน้อยกว่า 20 ปีโดยไม่ได้รับความยินยอมจากผู้ปกครองตามที่กฎหมายกำหนด หรือเป็นของคนเสมือนไร้ความสามารถหรือคนไร้ความสามารถโดยไม่ได้รับความยินยอมจากผู้พิทักษ์หรือผู้อนุบาลตามกฎหมาย
                                </p>
                                <p className="">
                                  1.7 นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ได้รับการปรับปรุงครั้งล่าสุดเมื่อ 1 มิถุนายน พ.ศ. 2565 แฟลชเวิร์ค สงวนสิทธิ์ โดยมีดุลยพินิจแต่เพียงผู้เดียว ในการปรับเปลี่ยน แก้ไข ลบ และปรับปรุงนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้เป็นครั้งคราว แฟลชเวิร์ค จะใช้ความพยายามตามสมควรเพื่อแจ้งให้คุณทราบและในลักษณะที่เหมาะสมถึงการปรับเปลี่ยนข้อกำหนดใดของนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ (เช่น โดยส่งนโยบายที่แก้ไขให้คุณทางอีเมล หรือโดยประกาศการเปลี่ยนแปลงดังกล่าวในช่องทางการสื่อสารของเรา) หากการเปลี่ยนแปลงใดๆ ของนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ต้องได้รับความยินยอมจากคุณตามกฎหมายที่ใช้บังคับ เราจะขอความยินยอมจากคุณเพื่อให้สอดคล้องกับการเปลี่ยนแปลงดังกล่าว
                                </p>
                                <br />
                                <p className="height-unset"><b>2. ข้อมูลส่วนบุคคลที่เราเก็บรวบรวมจากคุณ</b></p>
                                <p>
                                  เราอาจมีการเก็บรวบรวมหรือรับข้อมูลประเภทดังต่อไปนี้ซึ่งอาจรวมไปถึงข้อมูลส่วนบุคคลของคุณโดยตรงหรือโดยอ้อมจากคุณ หรือแหล่งข้อมูลอื่นๆ บริษัทอื่นๆ พันธมิตรทางธุรกิจ (เช่น บริษัทประกันภัย หรือสถาบันการเงิน เป็นต้น) หน่วยงานรัฐบาล หรือแหล่งข้อมูลอื่นๆ ที่เปิดเผยต่อสาธารณะ
                                  ลักษณะของบริการที่คุณขอ หรือลักษณะของปฏิสัมพันธ์ระหว่างคุณกับเราจะเป็นตัวกำหนดว่าเราเก็บข้อมูลส่วนบุคคลประเภทใด
                                </p>
                                <p>
                                  2.1 ข้อมูลที่คุณให้แก่เรา ซึ่งรวมถึง ข้อมูลเกี่ยวกับคุณที่คุณให้ไว้กับเราด้วยการสื่อสารกับเราผ่านช่องทางการสื่อสาร ข้อมูลดังกล่าวอาจรวมถึง แต่ไม่จำกัดเฉพาะ
                                </p>
                                <p>
                                    (1) ข้อมูลที่ระบุตัวตน เช่น คำนำหน้าชื่อ ชื่อ นามสกุล ชื่อเล่น เพศ อายุ วันเกิด อาชีพ ตำแหน่งงาน รายละเอียด และ/หรือ สำเนาบัตรประจำตัวประชาชน สำเนาหนังสือเดินทาง สำเนาทะเบียนบ้าน และสำเนาบัตรที่ออกโดยหน่วยงานราชการ หมู่เลือด รูปถ่าย ลายมือชื่อ และข้อมูลอื่นใดที่คุณเลือกที่จะแบ่งปันให้แก่เราซึ่งอาจถือว่าเป็นข้อมูลส่วนบุคคล
                                </p>
                                <p>
                                    (2) ข้อมูลเพื่อการติดต่อ เช่น หมายเลขโทรศัพท์ หมายเลขโทรศัพท์มือถือ หมายเลขโทรสาร ที่อยู่ รหัสไปรษณีย์ อีเมล อีเมลของบริษัท หมายเลขโทรศัพท์ทางธุรกิจ ที่อยู่ทางธุรกิจ (ซึ่งรวมถึงเมือง รหัสไปรษณีย์ และประเทศ) และชื่อผู้ใช้ในโซเชียลมีเดีย (เช่น ชื่อผู้ใช้ Facebook และ Line ID)
                                </p>
                                <p>
                                    (3) ข้อมูลการเงิน เช่น เงินเดือน ช่วงเงินเดือน สลิปเงินเดือน หนังสือรับรองเงินเดือน เป็นต้น
                                </p>
                                <p>
                                    (4) ข้อมูลเกี่ยวกับการบริการ เช่น ข้อมูลเกี่ยวกับการใช้บริการ วันที่ใช้บริการ ข้อมูลทางประชากรศาสตร์ ประวัติการติดต่อ (ระหว่างคุณกับ แฟลชเวิร์ค) ความพึงพอใจของลูกค้าต่อบริการ และข้อมูลที่เกี่ยวข้องกับการเรียกร้อง
                                </p>
                                <p>
                                    (5) ข้อมูลอื่นๆ เช่น ความคิดเห็น คำถาม การสอบถาม ข้อร้องเรียน คำตอบสำหรับแบบสอบถาม ความชื่นชอบ ความสนใจ หรืองานอดิเรก และ
                                </p>
                                <p>
                                    (6) ข้อมูลที่ละเอียดอ่อน เช่น ศาสนาในบัตรประจำตัวประชาชน เชื้อชาติในเอกสารการยืนยันตัวตน และ ข้อมูลชีวภาพ (เช่น ข้อมูลจำลองลายนิ้วมือ ข้อมูลภาพจำลองใบหน้า และข้อมูลจำลองม่านตา)
                                </p>
                                <p>
                                  2.2 ข้อมูลที่ แฟลชเวิร์ค เก็บรวบรวมเกี่ยวกับคุณ สำหรับการให้บริการ เราอาจเก็บรวบรวมข้อมูลต่อไปนี้จากการที่คุณใช้เว็บไซต์หรือแอปพลิเคชันของเรา ผ่านช่องทางการสื่อสารของเรา หรือจากแหล่งข้อมูลอื่นๆ โดยอัตโนมัติ
                                </p>
                                <p>
                                    (1) ข้อมูลที่ระบุตัวตน เช่น ภาพนิ่ง ภาพเคลื่อนไหว รูปภาพ และ/หรือ เสียง
                                </p>
                                <p>
                                    (2) ข้อมูลตำแหน่งทางภูมิศาสตร์ ของอุปกรณ์สื่อสารของคุณ (ซึ่งรวมถึงข้อมูลลองจิจูด/ละติจูด ตำแหน่งของเมืองและถนน)
                                </p>
                                <p>
                                    (3) ข้อมูลทางเทคนิค เช่น หมายเลขที่ใช้สำหรับระบุตัวตนของเครื่องคอมพิวเตอร์ (ที่อยู่ไอพี) ที่ใช้ในการเชื่อมต่ออุปกรณ์เคลื่อนที่ของคุณกับอินเตอร์เน็ต ข้อมูลการเข้าสู่ระบบ ข้อมูลการปฏิบัติการ ประเภทและเวอร์ชั่นของแพลตฟอร์มปฏิบัติการ การตั้งค่าเขตเวลา คุกกี้ พิกเซล การจราจร และการรายงานด้านความปลอดภัย ซึ่งรวมถึง ข้อมูลเกี่ยวกับการใช้อินเทอร์เน็ตของผู้ใช้คอมพิวเตอร์ขององค์กร (เช่น ผู้ใช้แต่ละรายเข้าเว็บไซต์อะไรบ้าง ดาวน์โหลดเอกสารอะไรบ้าง เหตุการณ์ด้านความปลอดภัย มาตรการป้องกันโดยเกตเวย์ ฯลฯ) ข้อมูลกิจกรรมที่เกี่ยวข้องกับการเผยแพร่เนื้อหา การสร้างเป้าหมายหรือการใช้เอกสารที่ได้รับการคุ้มครองบนเว็บไซต์ เช่น การเปลี่ยนการอนุญาตและข้อมูลของเอกสารเกี่ยวกับบุคคลที่กระทำกิจกรรมดังกล่าว และ
                                </p>
                                <p>
                                    (4) คุกกี้ เมื่อคุณเข้าเว็บไซต์หรือแอปพลิเคชัน จะมีการใช้คุกกี้เพื่อเก็บรวบรวมข้อมูลทางเทคนิคเกี่ยวกับบริการที่คุณใช้ และวิธีการที่คุณใช้บริการดังกล่าว สำหรับข้อมูลเพิ่มเติม โปรดดูข้อ 5 ของนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้
                                </p>
                                <p>
                                  แม้ว่าข้อมูลใดภายใต้ข้อ 2. อาจไม่ใช่ข้อมูลส่วนบุคคล แต่ถ้ารวมกับข้อมูลอื่นหรือข้อมูลส่วนบุคคลที่เกี่ยวข้อง ข้อมูลดังกล่าวอาจใช้ระบุตัวตนคุณได้ จึงถือว่าเป็นข้อมูลส่วนบุคคลได้เช่นกัน ดังนั้น เราจะปฏิบัติกับข้อมูลนี้โดยใช้มาตรฐานเดียวกับข้อมูลส่วนบุคคล อย่างไรก็ตาม เมื่อเราประมวลผลข้อมูลที่ไม่สามารถระบุตัวตนได้หรือในรูปแบบข้อมูลสถิติซึ่งไม่สามารถระบุตัวคุณได้อีกต่อไป ในกรณีนี้ นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้จะไม่ใช้บังคับ
                                </p>
                                <br />
                                <p className="height-unset"><b>3. เหตุใดเราจึงเก็บรวบรวม ใช้ เก็บรักษา เปิดเผย และ/หรือโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลของคุณและอาศัยฐานทางกฎหมายใดเพื่อใช้รับรองกิจกรรมดังกล่าว</b></p>
                                <p>
                                  แฟลชเวิร์ค และบุคคลที่สามที่อาจกระทำการแทนเรา อาจเก็บรวบรวม ใช้ เก็บรักษา เปิดเผย และ/หรือโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลของคุณตามที่ได้อธิบายไป โดยอาศัยฐานโดยชอบด้วยกฎหมายอันได้แก่ (1) ความยินยอมของคุณ (2) ความจำเป็นในการปฏิบัติตามข้อสัญญากับคุณ สำหรับการริเริ่มหรือการดำเนินการตามสัญญากับคุณ (3) ประโยชน์โดยชอบด้วยกฎหมาย เพื่อวัตถุประสงค์ว่าด้วยประโยชน์โดยชอบด้วยกฎหมายของเรา และประโยชน์โดยชอบด้วยกฎหมายของบุคคลที่สาม เพื่อให้สมดุลกับประโยชน์ของคุณและสิทธิเสรีภาพขั้นพื้นฐานของคุณในส่วนที่เกี่ยวข้องกับการคุ้มครองข้อมูลส่วนบุคคลของคุณ (4) การปฏิบัติตามกฎหมายของเรา (5) ประโยชน์ต่อชีวิต กล่าวคือ ป้องกันหรือระงับอันตรายต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล และ (6) เพื่อก่อตั้งสิทธิเรียกร้องตามกฎหมายและยกขึ้นต่อสู้ซึ่งสิทธิเรียกร้องในทางกฎหมายในอนาคต เพื่อวัตถุประสงค์ดังต่อไปนี้
                                </p>
                                3.1 วัตถุประสงค์ที่จำเป็นต้องมีความยินยอมของคุณ
                                <p>
                                  (1) การตลาดและการติดต่อสื่อสาร เพื่อทำการตลาด การทำการตลาดซ้ำ การสื่อสาร การขาย การเสนอข้อเสนอพิเศษ การเสนอโปรโมชั่น การแจ้งเตือน การแจ้งข่าวสารและข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการ จาก แฟลชเวิร์ค บริษัทในกลุ่ม ผู้จำหน่ายที่ได้รับอนุญาต และ/หรือ พันธมิตรทางธุรกิจ ในกรณีที่เราไม่สามารถใช้ฐานทางกฎหมายอื่นได้
                                </p>
                                <br />
                                <p>
                                  (2) ข้อมูลส่วนบุคคลที่ละเอียดอ่อน เพื่อการเก็บรวบรวม ใช้ เก็บรักษา เปิดเผย และ/หรือโอนไปยังต่างประเทศซึ่งข้อมูลส่วนบุคคลที่ละเอียดอ่อนของคุณเพื่อวัตถุประสงค์ต่างๆ ที่กฎหมายกำหนดว่าต้องได้รับความยินยอม ซึ่งได้แก่ ศาสนาของคุณในบัตรประจำตัวประชาชน เชื้อชาติในเอกสารยืนยันตัวตน และข้อมูลชีวภาพ (เช่น ข้อมูลจำลองลายนิ้วมือ ข้อมูลภาพจำลองใบหน้า และข้อมูลจำลองม่านตา) สำหรับการยืนยันและพิสูจน์ตัวตน
                                </p>
                                <p>
                                  หากฐานทางกฎหมายคือความยินยอม คุณมีสิทธิที่จะถอนความยินยอมได้ตามเงื่อนไขที่ระบุไว้ใน นโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ทั้งนี้ การถอนความยินยอมจะไม่กระทบต่อความชอบด้วยกฎหมายของการเก็บรวบรวม ใช้ และเปิดเผยข้อมูลส่วนบุคคลและข้อมูลส่วนบุคคลของคุณที่เราได้มาโดยอาศัยความยินยอมของคุณก่อนที่จะถอนความยินยอม
                                </p>
                                <p>
                                  3.2 วัตถุประสงค์ที่เราอาจดำเนินการโดยอาศัยฐานทางกฎหมายอื่นๆ เพื่อการประมวลผลข้อมูลส่วนบุคคลของคุณ
                                </p>
                                <p>
                                  การให้ข้อมูล เพื่อให้ข้อมูลที่เกี่ยวข้องกับประสิทธิภาพของบริการ ผลิตภัณฑ์ เว็บไซต์ และแอปพลิเคชันของเรา ซึ่งรวมถึงปัญหาต่างๆ เช่น บั๊ก หรือปัญหาด้านการเชื่อมต่อ เพื่อแจ้งความคืบหน้าต่างๆ รวมถึงการแก้ไขปัญหา เพื่อตอบข้อสงสัยของคุณและดำเนินการตามคำขอของคุณ หรือเพื่อตอบกลับคำถามและความคิดเห็นของคุณ เพื่อส่งข้อมูลด้านบริหารจัดการให้แก่คุณ (เช่น การเปลี่ยนแปลงไปยังข้อกำหนด เงื่อนไข และนโยบาย) เพื่อทำความเข้าใจคำติชมเกี่ยวกับผลิตภัณฑ์ของ แฟลชเวิร์ค และช่วยให้ข้อมูลเพิ่มเติมเกี่ยวกับการใช้งานผลิตภัณฑ์และบริการเหล่านั้นได้อย่างรวดเร็วและง่ายดาย เพื่อติดต่อสื่อสารกับคุณเพื่อให้บริการหรือข้อมูลเกี่ยวกับ แฟลชเวิร์ค และผลิตภัณฑ์ของ แฟลชเวิร์ค เพื่อเสนอค่าบริการ และเพื่อให้ข้อมูลเกี่ยวกับการบริการ
                                  การประกอบธุรกิจ เพื่อดำเนินการตามข้อกำหนดด้านการเก็บรักษาบันทึกเป็นการภายในเกี่ยวกับการใช้แอปพลิเคชันเพื่อรวบรวมสถิติหรือทำรายงานเป็นการภายใน เพื่อวิเคราะห์และจัดการธุรกิจของเรา เพื่อทำการวิจัยด้านการตลาด การตรวจสอบบัญชี ระบุแนวโน้มหรือแนวทางการใช้งาน ตรวจสอบประสิทธิภาพของแคมเปญการส่งเสริมการขายและโฆษณาของเรา ประเมินความพึงพอใจของลูกค้า บังคับใช้ข้อกำหนดและเงื่อนไขของเรา เพื่อทำการประมวลข้อมูลการวิเคราะห์ทางสถิติ เพื่อใช้งานข้อมูลส่วนบุคคลของคุณในการวิเคราะห์ภายใน เพื่อประเมินการวิเคราะห์ภัยคุกคามในเชิงลึก เพื่อจัดการและบริหารการดำเนินธุรกิจของเราอย่างมีประสิทธิภาพและมีประสิทธิผล เพื่อประสานงานกับฝ่ายจัดการด้านเทคนิคและการรับประกันและฝ่ายจัดการด้านข้อมูล เพื่อทำการจัดการความเสี่ยง ดำเนินการตรวจสอบภายใน และประเมินความเสี่ยง และเพื่อจัดการธุรกิจภายในเพื่อให้เป็นไปตามข้อกำหนด นโยบาย และกระบวนการต่างๆ
                                  การพัฒนาผลิตภัณฑ์/บริการ เพื่อพัฒนาการจัดหาบริการและผลิตภัณฑ์ของเรา ซึ่งรวมถึง ช่องทางการสื่อสารของเรา เพื่อดำเนินการให้แน่ใจว่าเนื้อหาจากช่องทางการสื่อสารของเราได้รับการนำเสนออย่างมีประสิทธิภาพสำหรับคุณและอุปกรณ์ของคุณ เพื่อพัฒนาผลิตภัณฑ์ใหม่ๆ เพื่อปรับปรุงและปรับประสบการณ์และเนื้อหาของช่องทางการสื่อสารตามกิจกรรมของคุณบนช่องทางการสื่อสารของเราจากข้อมูลประวัติการใช้ช่องทางการสื่อสารของเรา เพื่อสร้างรายงานด้านประชากรและการแบ่งกลุ่มลูกค้าเพื่อปรับปรุงกลยุทธ์ทางธุรกิจของเรา เพื่อสร้างรายงานระบบการจัดการเป็นการภายใน และเพื่อสร้างกลยุทธ์ทางการตลาดและโฆษณาสำหรับแต่ละบุคคล
                                  การสื่อสารด้านการตลาด เพื่อทำการตลาด การทำการตลาดซ้ำ การสื่อสาร การขาย การเสนอข้อเสนอพิเศษ การเสนอโปรโมชั่น การแจ้งเตือน การแจ้งข่าวสารและข้อมูลเกี่ยวกับผลิตภัณฑ์และบริการ จาก แฟลชเวิร์ค และ/หรือ พันธมิตรทางธุรกิจ เพื่อสร้างโฆษณาบนอินเทอร์เน็ตตามความสนใจ/พฤติกรรมของลูกค้า เพื่อสร้างกลยุทธ์ทางการตลาดและโฆษณาสำหรับแต่ละบุคคล เพื่อสร้างโฆษณาจากคุกกี้และการติดตามพิกเซล เพื่อบันทึกภาพนิ่ง ภาพเคลื่อนไหว ภาพถ่าย และ/หรือ เสียง สำหรับการสร้างเนื้อหาการประชาสัมพันธ์ และการตลาด (เช่น โพสต์ทางโซเชียลมีเดีย หรือสำหรับการถ่ายทอดสด) เพื่อทำการตลาดโดยอิงกลุ่มเป้าหมายผ่านทางอีเมล/หมายเลขโทรศัพท์ เพื่อกระจายข้อมูลและข่าวสารเกี่ยวกับงานกิจกรรม และเพื่อใช้ข้อมูลของคุณในการโฆษณาความคิดเห็นของลูกค้า
                                  การสื่อสารกับคุณ เพื่อทำความเข้าใจความต้องการและความสนใจของคุณ เพื่อทำการสำรวจ เพื่อการศึกษาวิจัย เพื่อสอบถามถึงพฤติกรรม ทัศนคติ การรับรู้ ความสนใจ ความต้องการ และอิทธิพลในการตัดสินใจต่อผลิตภัณฑ์และบริการเพื่อสอบถามความพึงพอใจของคุณกับผลิตภัณฑ์และบริการของเรา เพื่อจัดการนัดหมายลูกค้าเพื่อการสื่อสารที่เกี่ยวข้องกับการใช้บริการ เพื่อดำเนินการตามคำขอใช้บริการ
                                  การทำงานและการบริหารจัดการช่องทางการสื่อสารของเรา เพื่อบริหารจัดการและดำเนินการกับช่องทางการสื่อสารของเรา ฟังก์ชันของช่องทางการสื่อสาร และบริการที่ให้โดยเกี่ยวเนื่องกับแอปพลิเคชันและเว็บไซต์ เพื่อทำการตรวจสอบและปรับปรุงข้อมูลที่ให้ในช่องทางการสื่อสารของเราให้เป็นมิตรกับผู้ใช้และป้องกันเหตุขัดข้องหรือการโจมตีทางไซเบอร์ เพื่อทำการตรวจสอบและวิเคราะห์ทางสถิติเกี่ยวกับการโจมตีอุปกรณ์และระบบ เพื่อบริหารจัดการและบำรุงรักษาฐานข้อมูลที่เก็บข้อมูลส่วนบุคคล เพื่อตรวจสอบการใช้งานวัสดุต่างๆ ที่มีลิขสิทธิ์ เพื่อทำการติดตามคุกกี้และตรวจสอบพฤติกรรมและประวัติการใช้งานอินเทอร์เน็ตและบันทึกข้อมูลต่างๆ เพื่อให้ช่องทางการสื่อสารและผลิตภัณฑ์หรือบริการที่เสนอให้แก่คุณทำงานได้อย่างปกติ การวัดเรตติ้ง การตรวจสอบการใช้งานและความปลอดภัย และเพื่อตรวจสอบดูแลอะไหล่รถยนต์ที่ได้รับการเปลี่ยนในช่วงระยะเวลาหนึ่งเพื่อให้แน่ใจถึงความปลอดภัยของลูกค้า
                                  การบริหารจัดการทางด้านเทคโนโลยีสารสนเทศ เพื่อวัตถุประสงค์ในการบริหารจัดการธุรกิจของเรา รวมถึงการจัดการระบบปฏิบัติการด้านเทคโนโลยีสารสนเทศ การจัดการระบบติดต่อสื่อสาร ระบบความปลอดภัยทางด้านเทคโนโลยีสารสนเทศ และการตรวจสอบความปลอดภัยทางด้านเทคโนโลยีสารสนเทศ เพื่อทำการวิเคราะห์ที่จำเป็นเพื่อตรวจจับข้อมูลที่ประสงค์ร้ายและทำความเข้าใจว่าข้อมูลเหล่านี้จะกระทบต่อระบบเทคโนโลยีสารสนเทศได้อย่างไรบ้าง เพื่อปรับใช้วิธีการแก้ไขต่างๆ อย่างต่อเนื่องเพื่อรักษาความปลอดภัยของอุปกรณ์และระบบจากการโจมตี เพื่อให้วิธีการแก้ไขและรักษาความปลอดภัยที่ดีที่สุดและเป็นปัจจุบันสำหรับอุปกรณ์มือถือและระบบไอที และอัปเดตโซลูชันการรักษาความปลอดภัยของเรา
                                  การปฏิบัติตามกฎหมาย เพื่อประมวลผลข้อมูลส่วนบุคคลของคุณ (รวมถึงเพื่อการป้องกันอาชญากรรมและการทุจริต และวัตถุประสงค์อื่นๆ ที่เกี่ยวข้อง) ตามภาระผูกพันที่กฎหมายกำหนด สิทธิและหน้าที่ภายใต้กฎหมายที่ใช้บังคับ รวมถึงกฎหมายนอกประเทศที่คุณอาศัยอยู่ เพื่อประเมินการปฏิบัติตามกฎหมายที่ใช้บังคับ กฎระเบียบ ข้อบังคับ และนโยบายและกระบวนการภายใน และเพื่อดำเนินการตามการสอบสวนที่เจ้าหน้าที่รัฐกำหนด
                                  การปกป้องสิทธิและผลประโยชน์ของเรา เพื่อปกป้องสิทธิ ทรัพย์สิน ความปลอดภัย หรือการดำเนินการของเราหรือของบริษัทในกลุ่ม หรือ คุณ หรือ บุคคลอื่นๆ เพื่อให้เราสามารถขอการเยียวยาหรือจำกัดความเสียหายที่อาจเกิดขึ้นกับเรา เพื่อบังคับใช้หรือบังคับใช้สัญญาการได้รับสิทธิ (license) ในการใช้แอปพลิเคชันของผู้ใช้ปลายทางและข้อตกลงอื่นๆ หรือเพื่อสอบสวนในกรณีที่สงสัยว่ามีการละเมิดข้อตกลงดังกล่าว เพื่อก่อตั้ง ใช้ หรือยกขึ้นต่อสู้ซึ่งสิทธิตามกฎหมายของเราหรือการดำเนินการตามกฎหมาย และในกรณีของการขาย โอน ควบรวม ฟื้นฟูกิจการ หรือเหตุการณ์อื่นที่คล้ายกัน เราอาจต้องทำการโอนข้อมูลของคุณให้แก่บุคคลที่สามโดยถือว่าการกระทำดังกล่าวเป็นส่วนหนึ่งของการทำธุรกรรม
                                  การตรวจจับการทุจริต เพื่อพิสูจน์ตัวตนของคุณ และเพื่อดำเนินการตรวจสอบทางกฎหมายหรือกฎข้อบังคับอื่นๆ และป้องกันการทุจริต ทั้งนี้ รวมไปถึงการตรวจสอบและการทำบันทึกภายใน การจัดการทรัพย์สิน ฐานข้อมูลด้านการทุจริต ระบบ และการควบคุมทางธุรกิจอื่นๆ
                                  ชีวิต เพื่อป้องกันหรือระงับอันตรายที่เกิดต่อชีวิต ร่างกาย หรือสุขภาพของบุคคล
                                </p>
                                <br />
                                <p className="height-unset"><b>4. การเปิดเผยข้อมูลส่วนบุคคลของคุณแก่บุคคลที่สาม</b></p>
                                <p>
                                  4.1 เราอาจแบ่งปันข้อมูลส่วนบุคคลของคุณภายในเครือข่ายของ แฟลชเวิร์ค เพื่อวัตถุประสงค์ที่ได้อธิบายข้างต้น เราจะดำเนินการตามขั้นตอนดังกล่าวเพื่อให้แน่ใจกว่าการเข้าถึงข้อมูลส่วนบุคคลจำกัดเฉพาะพนักงานและตัวแทนของ แฟลชเวิร์ค เท่านั้นโดยอาศัยพื้นฐานของความจำเป็นต้องรู้ข้อมูล (need-to-know basis)
                                </p>
                                <p>
                                  4.2 นอกจากนี้เราอาจแบ่งปันข้อมูลส่วนบุคคลของคุณออกนอกเครือข่ายของ แฟลชเวิร์ค ให้แก่บุคคลต่อไปนี้ เพื่อวัตถุประสงค์ที่ระบุไว้ในนโยบายนี้
                                </p>
                                <p>
                                    (1) พันธมิตรทางธุรกิจ เพื่อประกอบธุรกิจและบริการที่เกี่ยวข้องกับธุรกิจของเรา ไม่ว่าจะเป็นกรณีที่ แฟลชเวิร์ค อาจเปิดเผยแก่และได้รับข้อมูลส่วนบุคคลของคุณจากพันธมิตรทางธุรกิจ ดังกล่าว (เช่น บริษัทประกันภัย สถาบันทางการเงิน บริษัทให้สินเชื่อเช่าซื้อรถยนต์ ผู้ให้บริการทางการเงิน) ซึ่งรวมถึง พันธมิตรของเราที่ขายผลิตภัณฑ์หรือบริการของเราให้แก่คุณ หรือผู้ที่เสนอผลิตภัณฑ์หรือบริการร่วมกับเรา หรืออาจมีการเสนอผลิตภัณฑ์หรือบริการของพันธมิตรเหล่านี้ให้แก่คุณ
                                </p>
                                <p>
                                    (2) ผู้จำหน่ายและตัวแทนขายที่ได้รับการแต่งตั้ง ในบางครั้ง แฟลชเวิร์ค อาจเปิดเผยและได้รับข้อมูลส่วนบุคคลจากผู้จำหน่ายที่ได้รับการแต่งตั้งที่คุณเลือก หรืออยู่ใกล้กับคุณ เพื่อให้บริการแก่คุณ
                                </p>
                                <p>
                                    (3) ผู้ให้บริการ / ผู้จัดหาผลิตภัณฑ์/บริการ / ผู้รับจ้างช่วง เราอาจใช้บริการของบริษัท ตัวแทน หรือผู้รับจ้างอื่นในการให้บริการแทนเราหรือเพื่อช่วยเหลือในการจัดหาผลิตภัณฑ์และบริการให้แก่คุณ เราอาจแบ่งปันข้อมูลส่วนบุคคลของคุณกับผู้ให้บริการหรือผู้จัดหาผลิตภัณฑ์/บริการจากภายนอกของเรา ซึ่งรวมถึงแต่ไม่จำกัดเฉพาะ (1) ผู้ให้บริการระบบเทคโนโลยีสารสนเทศและบริษัทเทคโนโลยีสารสนเทศ (2) ผู้ให้บริการวิเคราะห์หรือทำวิจัย เช่น กูเกิล (3) บริษัทที่ให้บริการวิเคราะห์เชิงสถิติ (4) บริษัทที่ให้บริการสำรวจ (5) บริษัทที่ให้บริการการตลาด สื่อโฆษณา การออกแบบ การสร้างสรรค์ และการสื่อสาร (6) ผู้จัดแคมเปญ งานกิจกรรม และการตลาด (7) ผู้ให้บริการด้านการบริหาร และ (8) ผู้ให้บริการจัดเก็บข้อมูลและบริการคลาวด์
                                </p>
                                <p>
                                    (4) ที่ปรึกษาจากภายนอก ซึ่งรวมถึง ทนายความ ช่างเทคนิค และผู้ตรวจสอบบัญชีซึ่งช่วยเหลือในการดำเนินธุรกิจของเรา หรือ การใช้สิทธิเรียกร้องตามกฎหมาย
                                </p>
                                <p>
                                    (5) บุคคลที่สามตามที่กฎหมายกำหนด ในบางกรณี เราอาจต้องเปิดเผยหรือแบ่งปันข้อมูลส่วนบุคคลของคุณเพื่อปฏิบัติตามกฎหมายหรือกฎระเบียบ ซึ่งรวมถึงหน่วยงานบังคับใช้กฎหมาย (เช่น กรมการขนส่งทางบก กรมสรรพากร สำนักงานคณะกรรมการคุ้มครองผู้บริโภค) ศาล ผู้บังคับใช้กฎหมาย หน่วยงานรัฐบาล หรือบุคคลที่สามอื่นๆ หากเราเชื่อว่ามีความจำเป็นต้องปฏิบัติตามภาระผูกพันตามกฎหมายหรือกฎระเบียบ หรือต้องปกป้องสิทธิของเรา สิทธิของบุคคลที่สาม หรือความปลอดภัยของบุคคล หรือเพื่อตรวจจับ ป้องกัน หรือแก้ไขปัญหาการทุจริต ความมั่นคง หรือความปลอดภัย
                                </p>
                                <p>
                                    (6) โรงพยาบาลและหน่วยกู้ภัย อาจมีการเปิดเผยข้อมูลส่วนบุคคลของคุณในกรณีฉุกเฉินเพื่อปกป้องประโยชน์ของคุณ
                                </p>
                                <p>
                                    (7) ผู้รับโอนสิทธิและ/หรือภาระหน้าที่ ในกรณีที่มีการฟื้นฟูกิจการ การควบรวมกิจการ การโอนธุรกิจ ไม่ว่าส่วนหนึ่งหรือทั้งหมด การขาย การซื้อ การร่วมลงทุน การมอบ การโอน หรือการจำหน่ายส่วนหนึ่งหรือทั้งหมดของธุรกิจของเรา ทรัพย์สินหรือหุ้น หรือธุรกรรมที่คล้ายกัน ทั้งนี้ บุคคลที่สามในฐานะผู้รับโอนสิทธิของเราจะปฏิบัติตามนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้เพื่อคุ้มครองข้อมูลส่วนบุคคลของคุณ
                                </p>
                                <p>
                                    (8) แหล่งข้อมูลอื่นๆ ที่เปิดเผยต่อสาธารณะ เช่น เว็บไซต์ โฆษณา และ/หรือแพลตฟอร์มโซเชียลมีเดีย 
                                </p>
                                <p>
                                    4.3 เท่าที่กฎหมายอนุญาต แฟลชเวิร์ค จะไม่มีความรับผิดใดๆ ทั้งสิ้นอันเกิดจากการใช้ข้อมูลส่วนบุคคลของคุณโดยบุคคลที่สาม ดังนั้น โปรดตรวจสอบนโยบายความเป็นส่วนตัวของบุคคลที่สามดังกล่าวเพื่อทำความเข้าใจว่าบุคคลเหล่านั้นใช้ข้อมูลส่วนบุคคลของคุณอย่างไร เมื่อได้รับคำขอ แฟลชเวิร์ค จะยืนยันชื่อของบุคคลที่สามแต่ละรายที่ได้รับหรือจะได้รับโอนข้อมูลส่วนบุคคลไปให้
                                </p>
                                <p>
                                    4.4 เว้นแต่ที่ระบุไว้ในนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ เราจะไม่เปิดเผย ขาย จำหน่ายจ่ายโอน หรือให้เช่าซึ่งข้อมูลส่วนบุคคลของคุณแก่บุคคลภายนอก ยกเว้นแต่เราจะได้รับอนุญาตจากคุณ หรือเพื่อทำธุรกรรมให้กับคุณ เราไม่เปิดเผยข้อมูลส่วนบุคคลของคุณกับบุคคลภายนอกเพื่อทำการตลาดแบบตรงของบุคคลภายนอกโดยไม่ได้รับความยินยอมโดยชัดแจ้งจากคุณก่อน
                                </p>
                                <br />
                                <p className="height-unset"><b>5. คุกกี้</b></p>
                                <p>
                                    5.1 คุกกี้ คือไฟล์ข้อความขนาดเล็กที่มีข้อมูลขนาดเล็กที่ถูกส่งไปยังเบราว์เซอร์ของผู้ใช้งานเว็บไซต์โดยเว็บเซิร์ฟเวอร์ และจัดเก็บไว้ในฮาร์ดดิสก์ของคอมพิวเตอร์เพื่อเก็บถาวร เก็บรวบรวมข้อมูลการนำทางเพื่อทำการวิเคราะห์ทางสถิติ และเสนอบริการผู้ใช้ตามความสนใจหรือตำแหน่งของผู้ใช้

                                    เมื่อคุณเข้าเยี่ยมชมช่องทางการสื่อสารของเรา โดยการยอมรับการเก็บคุกกี้ เราจะเก็บรวบรวมข้อมูลบางอย่างจากคุณโดยการใช้คุกกี้ในประวัติการเรียกใช้งาน โดยข้อมูลดังกล่าวรวมถึงจำนวนเพจที่เข้าชม พฤติกรรมการใช้งาน และเวลาที่ใช้ไปในช่องทางการสื่อสารของเรา เราใช้คุกกี้ที่เก็บในการทำให้เว็บไซต์ทำหน้าที่ต่างๆ ได้และเพื่อปรับปรุงประสบการณ์ออนไลน์ของคุณ

                                    สำหรับข้อมูลส่วนบุคคลที่เราเก็บรวบรวมจากการใช้คุกกี้ เราจะประมวลผลข้อมูลเหล่านี้ตามนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้
                                </p>
                                <p>
                                    5.2 คุกกี้ใช้อย่างไร คุกกี้ที่เราเก็บจากช่องทางการสื่อสารของเราใช้เพื่อวัตถุประสงค์ต่อไปนี้ กล่าวคือ เพื่อให้เว็บไซต์ทำหน้าที่ต่างๆ ได้ และเพื่อให้ผลิตภัณฑ์และบริการต่างๆ ที่เราเสนอให้คุณทำงานได้อย่างเหมาะสม เพื่อปรับปรุงบริการออนไลน์ของคุณ เพื่อทำการวัดเรตติ้ง เพื่อตรวจสอบดูแลความมั่นคงปลอดภัย เพื่อให้โฆษณาที่ถูกต้องที่สุดและสอดคล้องกับการเข้าชมครั้งล่าสุดของคุณ เพื่อสร้างรายงานภายใน และการโฆษณาในโซเชียลมีเดียและในสื่ออื่นๆ อย่างประสบผลสำเร็จ

                                    คุณสามารถปิดการตั้งค่าคุกกี้ได้โดยการเข้าไปที่การตั้งค่าของเบราว์เซอร์ของคุณและปรับการตั้งค่าความเป็นส่วนตัวเพื่อจำกัดการเก็บคุกกี้ในอนาคต
                                </p>
                                <br />
                                <p className="height-unset"><b>6. การโอนข้อมูลส่วนบุคคลไปต่างประเทศ</b></p>
                                <p>
                                    6.1 แฟลชเวิร์ค อาจโอนข้อมูลส่วนบุคคลที่เก็บรวบรวมจากคุณไปยังบริษัทที่เกี่ยวข้อง และพันธมิตรในต่างประเทศเพื่อให้บริการตามวัตถุประสงค์ที่ระบุข้างต้น เราอาจจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของคุณให้แก่บุคคลภายนอกที่อยู่ต่างประเทศตามวัตถุประสงค์ที่ระบุในนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ โดยการเปิดเผยข้อมูลส่วนบุคคลหรือการโอนข้อมูลส่วนบุคคลดังกล่าวอาจทำได้เมื่อได้รับความยินยอมของคุณ เว้นเสียแต่ว่า เราได้กำหนดนโยบายในการคุ้มครองข้อมูลส่วนบุคคลต่างหาก เพื่อการส่งหรือโอนข้อมูลส่วนบุคคลไปยังผู้ควบคุมข้อมูลส่วนบุคคลหรือผู้ประมวลผลข้อมูลส่วนบุคคลซึ่งอยู่ต่างประเทศและอยู่ในบริษัทในกลุ่ม เพื่อการประกอบกิจการหรือธุรกิจร่วมกัน หากนโยบายในการคุ้มครองข้อมูลส่วนบุคคลดังกล่าวได้รับการตรวจสอบและรับรองจากสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล หรือ จะอาศัยฐานทางกฎหมายอื่นได้ (เช่น เพื่อปฏิบัติตามข้อกำหนดแห่งสัญญาระหว่างเราและบุคคลอื่นเพื่อประโยชน์ของคุณ) ตามที่กฎหมายที่ใช้บังคับอนุญาต ให้สามารถกระทำได้โดยได้รับยกเว้นไม่ต้องได้รับความยินยอมจากคุณ
                                </p>
                                <br/>
                                <p className="height-unset"><b>7. ระยะเวลาที่เราเก็บข้อมูลส่วนบุคคลของคุณ</b></p>
                                <p>
                                  แฟลชเวิร์ค จะเก็บรักษาข้อมูลส่วนบุคคลของคุณในระยะเวลาเท่าที่จำเป็นอย่างสมเหตุสมผลเพื่อให้บรรลุตามวัตถุประสงค์ที่ระบุในนโยบายคุ้มครองข้อมูลส่วนบุคคลนี้ หากมีการดำเนินการทางกฎหมายหรือทางวินัย อาจต้องเก็บข้อมูลส่วนบุคคลของคุณไว้จนกว่าการดำเนินการนั้นจะสิ้นสุด ซึ่งรวมถึงระยะเวลาที่เป็นไปได้ในการยื่นอุทธรณ์ด้วย หลังจากนั้นข้อมูลส่วนบุคคลของคุณจะถูกลบหรือเก็บถาวรตามที่กฎหมายที่ใช้บังคับอนุญาต
                                </p>
                                <br />
                                <p className="height-unset"><b>8. มาตรการรักษาความมั่นคงปลอดภัย</b></p>
                                <p>
                                  แฟลชเวิร์ค มีมาตรการการรักษาความมั่นคงปลอดภัยที่เก็บรักษาข้อมูลส่วนบุคคลทั้งหมดที่เก็บรวบรวมและได้รับอย่างปลอดภัย เราใช้มาตรการความปลอดภัยทางเทคนิค องค์กร การบริหารจัดการ และทางกายภาพในการคุ้มครองข้อมูลส่วนบุคคลของคุณที่อยู่ในระบบของเราเพื่อป้องกันการสูญหาย การเข้าถึง การใช้ การเปลี่ยนแปลง การแก้ไข ความเสียหายโดยไม่ได้ตั้งใจ และการลบข้อมูลส่วนบุคคลโดยมิชอบด้วยกฎหมายหรือโดยปราศจากอำนาจ นอกจากนี้ เรายังจะตรวจสอบทบทวนมาตรการดังกล่าวเมื่อจำเป็น หรือเมื่อมีการเปลี่ยนแปลงทางเทคโนโลยี เพื่อให้มีการรักษาความมั่นคงปลอดภัยอย่างเหมาะสมและมีประสิทธิภาพ เมื่อ แฟลชเวิร์ค ได้รับข้อมูลส่วนบุคคลของคุณ เราจะดำเนินการตามกระบวนการและมาตรการการรักษาความมั่นคงปลอดภัยอย่างเคร่งครัดเพื่อพยายามป้องกันไม่ให้มีการเข้าถึงข้อมูลโดยไม่ได้รับอนุญาต
                                </p>
                                <br />
                                <p className="height-unset"><b>9. สิทธิของคุณในฐานะเจ้าของข้อมูลส่วนบุคคล </b></p>
                                <p>
                                  ในบางกรณี เราอาจขอให้คุณยืนยันตัวตนของคุณก่อนที่คุณจะใช้สิทธิในฐานะเจ้าของข้อมูลส่วนบุคคล ทั้งนี้เพื่อความเป็นส่วนตัวและเพื่อความมั่นคงปลอดภัยของคุณ
                                  ภายใต้บทบัญญัติแห่งกฎหมายที่ใช้บังคับ คุณอาจมีสิทธิตามที่ระบุไว้ดังนี้
                                </p>
                                <p>
                                    (1) การเข้าถึง: คุณอาจมีสิทธิในการขอเข้าถึงหรือขอรับสำเนาข้อมูลส่วนบุคคลที่เราเก็บรวบรวม ใช้ หรือเปิดเผยเกี่ยวกับคุณ ทั้งนี้ เพื่อความเป็นส่วนตัวและความปลอดภัยของคุณ เราอาจขอให้คุณพิสูจน์ตัวตนของคุณก่อนจะให้ข้อมูลตามที่คุณขอ
                                </p>
                                <p>
                                    (2) การแก้ไขให้ถูกต้อง: คุณอาจมีสิทธิขอให้มีการดำเนินการแก้ไขข้อมูลส่วนบุคคลของคุณที่เราได้เก็บรวบรวม ใช้ เก็บรักษา เปิดเผย และโอนไปยังต่างประเทศให้ ถูกต้อง เป็นปัจจุบัน สมบูรณ์ และไม่ก่อให้เกิดความเข้าใจผิด
                                </p>
                                <p>
                                    (3) การโอนย้ายข้อมูล: คุณอาจมีสิทธิขอรับข้อมูลส่วนบุคคลที่เรามีเกี่ยวกับคุณในรูปแบบที่มีการจัดระเบียบแล้วและสามารถอ่านได้ในรูปแบบอิเล็กทรอนิกส์ และเพื่อส่งหรือโอนข้อมูลดังกล่าวไปยังผู้ควบคุมข้อมูลส่วนบุคคลอื่น โดยต้องเป็น (ก) ข้อมูลส่วนบุคคลที่คุณได้ให้กับเรา และ (ข) กรณีที่เราได้รับความยินยอมจากคุณในการเก็บรวบรวม ใช้ หรือเปิดเผยหรือเพื่อปฏิบัติตามสัญญาที่เรามีกับคุณ
                                </p>
                                <p>
                                    (4) การคัดค้าน: คุณอาจมีสิทธิคัดค้านการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ เช่น การคัดค้านการตลาดแบบตรง
                                </p>
                                <p>
                                    (5) การขอให้ระงับการใช้: คุณอาจมีสิทธิขอให้ระงับการใช้ข้อมูลส่วนบุคคลของคุณในบางกรณี
                                </p>
                                <p>
                                    (6) การถอนความยินยอม: สำหรับวัตถุประสงค์ที่คุณได้ให้ความยินยอมให้เราเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของคุณ คุณมีสิทธิที่จะถอนความยินยอมของคุณ
                                </p>
                                <p>
                                    (7) การลบหรือทำลายข้อมูล: คุณอาจมีสิทธิขอให้เราดำเนินการลบหรือทำลาย หรือทำให้ข้อมูลส่วนบุคคลของคุณที่เราเก็บรวบรวม ใช้หรือเปิดเผย เป็นข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูล เว้นเสียแต่ว่า การเก็บรักษาข้อมูลดังกล่าวของเรานั้นเป็นไปเพื่อการปฏิบัติตามกฎหมาย หรือเพื่อก่อตั้งสิทธิเรียกร้องตามกฎหมาย เพื่อการใช้ หรือการยกขึ้นต่อสู้ซึ่งสิทธิเรียกร้องตามกฎหมาย
                                </p>
                                <p>
                                    (8) การยื่นเรื่องร้องเรียน: คุณอาจมีสิทธิยื่นเรื่องร้องเรียนไปยังหน่วยงานที่มีอำนาจในกรณีที่คุณเชื่อว่าการเก็บรวบรวม ใช้หรือเปิดเผยข้อมูลส่วนบุคคลของเรานั้นไม่ชอบด้วยกฎหมายหรือไม่สอดคล้องกับกฎหมายคุ้มครองข้อมูลที่ใช้บังคับ
                                </p>
                                <br />
                                <p className="height-unset"><b> 10. รายละเอียดการติดต่อเรา </b></p>
                                <p>
                                  ถ้าคุณมีความประสงค์ที่จะใช้สิทธิของคุณตามที่ระบุด้านบน หรือถ้าคุณมีข้อสงสัย ความคิดเห็น และ/หรือคำถามเกี่ยวกับข้อมูลส่วนบุคคลของคุณภายใต้นโยบายคุ้มครองข้อมูลส่วนบุคคลฉบับนี้ โปรดติดต่อเราที่
                                </p>
                                <p>
                                  10.1 ที่ตั้งสำนักงาน
                                </p>
                                <p>ที่อยู่: 58/17 ซอยพร้อมศรี2 ถนนสุขุมวิท39 แขวงคลองตันเหนือ เขตวัฒนา กรุงเทพฯ 10110 ประเทศไทย
                                  <br/>
                                   หมายเลขโทรศัพท์: 02-381-6204 (9.00 - 18.00น. เว้นวันหยุดราชการ)
                                  <br/>
                                   ที่อยู่อีเมล contact@flashwork.co.th
                                </p>
                              </ul>
                            </>
                          </div>
                      </div>
                    </div>
                </div>          
            </div>

            <div className="modal-footer justify-content-between ">

            <button
                id="modalPDPA_Close2"
                type="button"
                className="btn btn-default pull-right"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times; ปิด</span> 
              </button>
            </div>

          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
      
      {/* ###################### Modal More Detail  ###################### */}
      
    </>
  );
}

export default Login;
